import { Controller } from "@hotwired/stimulus";
import Coloris from "@melloware/coloris";

// Makes the entire inspector-color-field clickable: anywhere outside the
// hex text input or Coloris's swatch button forwards the click to the
// input so Coloris pops the picker.
export default class extends Controller {
  static targets = ["input"];

  open(event) {
    if (event.target === this.inputTarget) return;
    if (event.target.closest(".clr-field")) return;

    // If a Coloris picker is already open on a different field, close it
    // cleanly first, reverting any uncommitted state. Without this, switching
    // pickers can leak the previous picker's internal state (e.g. #000000)
    // back into the previously-active input.
    const picker = document.getElementById("clr-picker");
    if (picker?.classList.contains("clr-open")) {
      Coloris.close(true);
    }

    this.inputTarget.click();
  }
}
